import { hash } from '@ember/helper';

import { t } from 'ember-intl';
import momentFormat from 'ember-moment/helpers/moment-format';

import Component from 'umg-ember-backend/components/record-detail/forms';
import ContentWithSidebar from 'umg-ember-backend/components/ui/content-with-sidebar';
import Form from 'umg-ember-backend/components/ui/form';

import { SearchAdUser } from './search-ad-user';

export default class RecordDetailFormsUserComponent extends Component {
  // Defaults
  userTypeOptions = [
    {
      value: 'INTERNAL',
      label: 'Internal',
    },
    {
      value: 'EXTERNAL',
      label: 'External',
    },
    {
      value: 'SERVICE',
      label: 'Service',
    },
    {
      value: 'LEGACY',
      label: 'Legacy',
    },
  ];

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <ContentWithSidebar>
        <:content>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='userType'
              @type='select-value'
              @options={{this.userTypeOptions}}
            />
            <fieldset.field @property='name' />
            <fieldset.field @property='pass' @type='password' />
            <fieldset.field @property='description' @type='textarea' />
            <fieldset.field @property='oid' @disabled={{true}} />
          </form.fieldset>
        </:content>
        <:sidebar>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            <fieldset.field @property='cmsLivedate' @type='date-time' />
            <fieldset.field @property='cmsKilldate' @type='date-time' />
          </form.fieldset>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field @property='person' @type='belongs-to' />

            <fieldset.field
              @property='userRoles'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='sftpUsers'
              @type='has-many'
              @on={{hash openNewRecord=false deleteRecord=false}}
            />

            <fieldset.field
              @property='artists'
              @type='has-many'
              @on={{hash openNewRecord=false openRecord=false}}
            />
          </form.fieldset>
          <form.sections.meta>
            <label>
              {{t 'meta_box.labels.lastLogin'}}
            </label>
            <div class='u-margin-bottom-small'>
              {{momentFormat @model.lastLoginTime 'L LT'}}
            </div>
            <label>
              {{t 'meta_box.labels.lastLoginIp'}}
            </label>
            <div class='u-margin-bottom-small'>
              {{@model.lastLoginIp}}
            </div>
            <label>
              {{t 'record_detail.forms.user.meta_box.labels.lastLoginHistory'}}
            </label>
            <div class='u-margin-bottom-small'>
              {{#each @model.lastLoginHistory.entrys as |entry|}}
                {{momentFormat entry.timestamp 'L LT' 'X'}}
                -
                {{entry.note}}<br />
              {{/each}}
            </div>
          </form.sections.meta>
        </:sidebar>
      </ContentWithSidebar>
      <SearchAdUser @user={{@model}} />
    </Form>
  </template>
}
